<script setup lang="ts">
import BaseHeader from '@/components/base/BaseHeader.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const naverClientId = import.meta.env.VITE_NAVER_CLIENT_ID
const naverRedirectUrl = import.meta.env.VITE_NAVER_REDIRECT_URL
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
const googleRedirectUrl = import.meta.env.VITE_GOOGLE_REDIRECT_URL
const kakaoRedirectUrl = import.meta.env.VITE_KAKAO_REDIRECT_URL
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const naver_id_login: any

const isMobile = useIsMobile()
const router = useRouter()
onMounted(() => {
  const naverLogin = new naver_id_login(naverClientId, naverRedirectUrl)

  const state = naverLogin.getUniqState()
  naverLogin.setButton('white', 2, 40)
  naverLogin.setState(state)
  naverLogin.setPopup()
  naverLogin.init_naver_id_login()
})

const naverLogin = () => {
  const naverLogin = document.getElementById('naver_id_login')
  const url = naverLogin?.children[0].getAttribute('href') ?? ''

  console.log('url', url)

  window.location.href = url
}

const kakaoLogin = () => {
  window.Kakao.Auth.authorize({
    redirectUri: kakaoRedirectUrl,
  })
}

const googleLogin = () => {
  const url =
    'https://accounts.google.com/o/oauth2/v2/auth?client_id=' +
    googleClientId +
    '&redirect_uri=' +
    googleRedirectUrl +
    '&response_type=code' +
    '&scope=email profile '

  window.location.href = url
}

const closeLoginView = () => {
  router.back()
}
</script>

<template>
  <BaseHeader v-if="!isMobile" />
  <div class="login-view">
    <div class="login-view-mobile-container" v-if="isMobile">
      <div class="login-view-mobile-container-close" @click="closeLoginView">
        <img src="@/assets/svgs/close.svg" alt="닫기" />
      </div>
      <img class="friend-logo" src="@/assets/pngs/friend_mobile_logo.png" alt="프렌드" />
    </div>
    <div class="login-title-container" :class="{ 'flex-1': isMobile }">
      <div class="login-title title-lg" :class="{ 'title-md': isMobile }">
        가장 편한 방법으로<br />프렌드 시작하기
      </div>
      <div class="login-description body-md gray-600" :class="{ 'body-sm': isMobile }">
        1분이면 회원가입이 가능해요
      </div>
    </div>
    <div class="login-form-container">
      <div id="naver_id_login"></div>
      <div class="login-form-button naver body-md white" @click="naverLogin">
        <img class="login-form-button-icon naver" src="@/assets/pngs/naver.png" alt="네이버" />
        네이버로 시작하기
      </div>
      <div class="login-form-button kakao body-md" @click="kakaoLogin">
        <img class="login-form-button-icon kakao" src="@/assets/pngs/kakao.png" alt="카카오" />
        카카오톡으로 시작하기
      </div>
      <div class="login-form-button google body-md" @click="googleLogin">
        <img class="login-form-button-icon google" src="@/assets/pngs/google.png" alt="구글" />
        Google로 시작하기
      </div>
    </div>
  </div>
</template>

<style scoped>
#naver_id_login {
  display: none;
}

.login-view {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
  background-color: var(--white);
  flex-direction: column;
  padding: 20px;
}

.login-title-container {
  width: 414px;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.login-title-container.flex-1 {
  flex: 1;
}

.login-title {
  margin-bottom: 12px;
}

.login-description {
  margin-bottom: 28px;
}

.login-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-form-button {
  width: 414px;
  height: 56px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  position: relative;
  cursor: pointer;
}

.login-form-button.naver {
  background-color: #2db400;
}

.login-form-button.kakao {
  background-color: #fee500;
}

.login-form-button.google {
  background-color: #f6f6f8;
}

.login-form-button-icon {
  position: absolute;
  left: 20px;
}

.login-form-button-icon.naver {
  width: 17px;
  height: 16px;
  left: 22px;
}

.login-form-button-icon.kakao {
  width: 21px;
  height: 20px;
}

.login-form-button-icon.google {
  width: 17px;
  height: 20px;
}

@media (max-width: 1365px) {
  .login-view {
    height: 100vh;
    margin-top: 0px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  }

  .login-form-container {
    width: 100%;
    max-width: 560px;
    min-width: 335px;
    align-items: stretch;
  }

  .login-title-container,
  .login-form-button,
  .login-view-mobile-container {
    width: 100%;
    max-width: 560px;
    min-width: 335px;
  }

  .login-view-mobile-container {
    background-color: var(--white);
    display: flex;
    justify-content: start;
    align-items: start;
    flex-direction: column;
  }

  .login-view-mobile-container .friend-logo {
    width: 100px;
    height: 54px;
    margin-top: 74px;
    margin-bottom: 14px;
  }

  .login-view-mobile-container-close {
    width: 24px;
    height: 24px;
    align-self: end;
    cursor: pointer;
  }
}
</style>
